/**
 * Shared Tailwind CSS classes for blog content.
 * Ensures that the Rich Text Editor and published blog posts have identical formatting.
 */

export const BLOG_CONTENT_CLASS = "prose prose-invert max-w-none text-white/90 leading-relaxed [&>p]:mb-4 [&>p:last-child]:mb-0 [&>h1]:text-2xl [&>h1]:font-bold [&>h1]:text-white [&>h1]:mb-4 [&>h2]:text-xl [&>h2]:font-bold [&>h2]:text-white [&>h2]:mb-3 [&>h3]:text-lg [&>h3]:font-semibold [&>h3]:text-white [&>h3]:mb-2 [&_a]:text-white [&_a]:underline [&_a:hover]:text-white/80 transition cursor-pointer";
